import { currencyPrecisions } from '@shared/constants'
import { inject } from 'vue'

const injectionKey = Symbol('formatCurrency')

export default {
  install: (app, options = {}) => {
    app.config.globalProperties.$formatCurrency = function ThCurrencyFormatter(
      value,
      currency,
      formatterOptions = {}
    ) {
      //Intl.NumberFormat requires a currency
      if (!currency) return

      // ----------------------  locale  -----------------------
      const locale =
        formatterOptions?.locale ||
        options?.i18n?.global?.locale?.value ||
        'en-US'

      // ---------------------  precision  ----------------------
      let precision
      if (typeof formatterOptions.precision === 'number') {
        precision = formatterOptions.precision
      } else if (currencyPrecisions[currency]) {
        precision = currencyPrecisions[currency].precision
      } else {
        precision = 2
      }

      // 1. String input: truncate in string space so e.g. "8385.99999999999999999999992" → 8385.99 (avoids JS number rounding).
      // 2. Number input: truncate via math and fix float errors (epsilon correction) so e.g. 8385.3 → 8385.30, 19.99 → 19.99.
      const truncatedValue = (() => {
        if (typeof value === 'string') {
          const trimmed = value.trim()
          const match = trimmed.match(/^(-?)(\d+)\.(\d*)$/)
          if (match) {
            const [, sign, intPart, fracPart] = match
            const truncatedStr =
              precision === 0
                ? sign + intPart
                : sign + intPart + '.' + fracPart.slice(0, precision)
            return parseFloat(truncatedStr)
          }
        }
        const parsedValue = parseFloat(value)
        const multiplier = Math.pow(10, precision)
        let scaled = parsedValue * multiplier
        const rounded = Math.round(scaled)
        if (Math.abs(scaled - rounded) < 1e-9) scaled = rounded
        return Math.trunc(scaled) / multiplier
      })()

      // ---------------------  currencyDisplay  ----------------------
      const currencyDisplay = formatterOptions?.currencyDisplay || 'symbol'

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      }).format(truncatedValue)
    }

    app.provide(injectionKey, app.config.globalProperties.$formatCurrency)
  }
}

export const useFormatCurrency = () => inject(injectionKey)
